import {
  PostHogPersonProperties,
  PostHogGlobalProperties
} from './posthog-properties.types';
import { montarPropriedadesGlobais } from './posthog-globals';

export type UserRole =
  | 'integrador'
  | 'admin_condominio'
  | 'distribuidor'
  | 'sub_integrador';

export interface IdentificacaoPostHog {
  distinctId: string | number;
  personProps: PostHogPersonProperties;
  globalProps: PostHogGlobalProperties;
}

/**
 * Campos do usuário que a identificação consome. Todos opcionais porque o objeto vem do
 * storage sem validação — a ausência de `id` é tratada em tempo de execução.
 */
export interface UsuarioIdentificavel {
  id?: string | number;
  login?: string;
  integrador?: boolean;
  integradorId?: string | number;
  contas?: unknown[];
}

function definirUserRole(user: UsuarioIdentificavel): UserRole {
  if (user.integrador) {
    return 'integrador';
  }
  if (!user.contas || user.contas.length === 0) {
    return 'distribuidor';
  }
  return 'admin_condominio';
}

export function montarIdentificacaoPostHog(
  user: UsuarioIdentificavel,
  tenantId: number | undefined,
  idioma?: string
): IdentificacaoPostHog | null {
  if (!user || !user.id) {
    return null;
  }

  const userRole = definirUserRole(user);
  const integradorId = user.integrador ? user.integradorId : undefined;

  const personProps: PostHogPersonProperties = { user_role: userRole };
  if (user.login) {
    personProps.email = user.login;
  }
  if (integradorId !== undefined) {
    personProps.integrador_id = integradorId;
  }
  if (tenantId !== undefined) {
    personProps.tenant_id = tenantId;
  }

  const globalProps = montarPropriedadesGlobais({
    user_role: userRole,
    integrador_id: integradorId,
    tenant_id: tenantId,
    email: user.login || undefined,
    idioma: idioma || undefined
  });

  return { distinctId: user.id, personProps, globalProps };
}
